<template>
  <div>
    <LabelHeader msg="工时查询"></LabelHeader>
    <div >
      <el-form style="padding-top: 20px" :inline="true">
        <el-form-item label="周期：">
          <el-select
            size="small"
            style="width: 250px"
            v-model="searchParams.periodId"
            placeholder="请选择工时周期"
            @change="periodChange"
            clearable
          >
            <el-option
              v-for="item in period"
              :key="item.id"
              :label="item.start + '~' + item.end"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名：">
          <el-input
            size="small"
            style="width: 170px"
            v-model="searchParams.nickName"
            type="text"
            placeholder="输入姓名查询"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="search"
            size="mini"
            icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <LabelHeader msg="查询结果"></LabelHeader>
    <div class="contentBox">
      <el-table
        :data="items"
        :cell-style="{ padding: '0px' }"
        :header-row-style="{ height: '35px' }"
        :header-cell-style="{
          padding: '0px',
          background: '#f5f7fa',
          color: '#606266',
        }"
        :row-style="{ height: '35px' }"
        style="width: 100%"
        row-key="id"
        max-height="530"
        border
        stripe
        lazy
        show-checkbox
      >
        <af-table-column
          prop="nickName"
          label="姓名"
          align="center"
          width="150"
        ></af-table-column>
        <af-table-column label="周期" align="center">
          <template slot-scope="scope">
            {{ scope.row.start }}~{{ scope.row.end }}
          </template>
        </af-table-column>
        <af-table-column
          prop="planValue"
          label="计划"
          align="center"
          width="150"
        ></af-table-column>
        <af-table-column label="已填" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.actualValue >= scope.row.planValue"
              style="color: #2d7bf4"
            >
              {{ scope.row.actualValue }}
            </div>
            <div v-else style="color: red">{{ scope.row.actualValue }}</div>
          </template>
        </af-table-column>
        <af-table-column label="剩余" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.actualValue >= scope.row.planValue"
              style="color: #2d7bf4"
            >
              {{
                scope.row.planValue -
                (scope.row.actualValue === null ? 0 : scope.row.actualValue)
              }}
            </div>
            <div v-else style="color: red">
              {{
                scope.row.planValue -
                (scope.row.actualValue === null ? 0 : scope.row.actualValue)
              }}
            </div>
          </template>
        </af-table-column>
        <af-table-column label="状态" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.actualValue >= scope.row.planValue"
              style="color: #2d7bf4"
            >
              完成
            </div>
            <div v-else style="color: red">未完成</div>
          </template>
        </af-table-column>
        <af-table-column
          prop="createAt"
          label="创建时间"
          align="center"
          :width="160"
        ></af-table-column>
        <af-table-column
          prop="updateAt"
          label="更新时间"
          align="center"
          :width="160"
        ></af-table-column>

        <af-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              size="mini"
              :underline="false"
              @click="openEditDialog(scope.row.id)"
              >明细</el-link
            >&nbsp;
          </template>
        </af-table-column>
      </el-table>

      <el-dialog
        fullscreen
        title="填写工时"
        :visible.sync="editDialogVisible"
        v-if="editDialogVisible"
      >
        <Edit
          :sheetId="idParam"
          @close="close"
          @success="success"
          ref="bindEditForm"
        ></Edit>
      </el-dialog>

      <el-dialog
        fullscreen
        title="工时详情"
        :visible.sync="detailDialogVisible"
        v-if="detailDialogVisible"
      >
        <Detail
          :sheetId="idParam"
          @close="close"
          @success="success"
          ref="bindEditForm"
        ></Detail>
      </el-dialog>

      <div
        style="
          margin-top: 15px;
          display: flex;
          flex-wrap: nowrap;
          padding: 10px;
          justify-content: flex-end;
        "
      >
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @size-change="sizeChange"
          @current-change="currentChange"
          :page-size="pagination.size"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Detail from "./detail";
import Edit from "./edit";
import LabelHeader from "../../../eap/components/LabelHeader";

export default {
  data() {
    return {
      items: [], // 数据集合
      period: {},
      searchParams: {
        // 查询参数
        pageNo: 1,
        pageSize: 10,
        periodId: "",
        start: "",
        end: "",
        nickName: "",
      },
      rules: {
        periodId: [
          { required: true, message: "请选择工时周期", trigger: "change" },
        ],
        num: [{ required: true, message: "工时不能为空", trigger: "change" }],
      },
      idParam: "",
      pagination: { page: 1, size: 10, total: 0 }, // 分页参数
      refreshing: false, // 结果列表是否正在刷新
      editDialogVisible: false, // 编辑窗口是否可见
      detailDialogVisible: false, // 详情窗口是否可见
    };
  },
  components: { Edit, Detail, LabelHeader },
  computed: {},
  // 页面加载获取数据
  mounted() {
    this.refresh();
  },
  watch: {},
  methods: {
    sizeChange(size) {
      this.pagination.size = size;
      this.search();
    },
    currentChange(pageNo) {
      this.pagination.page = pageNo;
      this.search();
    },
    periodChange(val) {
      console.log(" periodChange: " + val);
      this.period.forEach((item) => {
        if (item.id === val) {
          this.searchParams.start = item.start;
          this.searchParams.end = item.end;
        }
      });
    },
    refresh() {
      this.refreshing = true;
      this.getPeriod();
      this.search();
    },
    getPeriod() {
      httpKit.post($api_pms.period.search, {}).then((res) => {
        if (res.data.code === "200") {
          this.period = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    search(value) {
      const searchLoad = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.searchParams.pageNo = value ? value.page : this.pagination.page;
      this.searchParams.pageSize = value ? value.size : this.pagination.size;
      httpKit
        .post($api_pms.sheet.search, this.searchParams)
        .then((res) => {
          this.refreshing = false;
          if (res.data.code === "200") {
            this.items = res.data.data;
            this.pagination.total = res.data.totalItems;
          } else if (res.data.code === "500") {
            this.items = [];
            this.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          searchLoad.close();
        });
    },
    deleteBatch() {
      let selection = this.$refs.table.getSelection();
      if (selection.length <= 0) {
        this.$message.error("请选择最少一条记录");
        return;
      }
      this.$Confirm("您确定要删除这条记录吗？")
        .then(() => {
          let idAryStr = (parameter = selection[0].id);
          for (let i = 1; i < selection.length; i++) {
            idAryStr += "," + selection[i].id;
          }
          jsKit.delete({ ids: idAryStr }, $api_pms.druid.delete).then((res) => {
            this.deleteCallback(res);
          });
        })
        .catch((error) => {
          this.$message.error("已取消");
        });
    },
    deleteItem(idVal) {
      this.$Confirm("您确定要删除这条记录吗？")
        .then(() => {
          jsKit.delete($api_pms.druid.delete, idVal).then((res) => {
            this.deleteCallback(res);
          });
        })
        .catch((error) => {
          this.$message.error("已取消");
        });
    },
    openEditDialog(idVal) {
      this.detailDialogVisible = true;
      this.idParam = idVal;
    },
    openDetailDialog(idVal) {
      this.idParam = idVal;
      this.detailDialogVisible = true;
    },
    deleteCallback(res) {
      if (res.data.code === "200") {
        this.$message.success("删除成功");
        this.refresh();
      } else if (res.data.code === "500") {
        this.$message.error("删除失败:" + res.data.msg);
      }
    },
    close() {
      this.editDialogVisible = false;
      this.detailDialogVisible = false;
      this.search();
    },
    success() {
      this.closeCallback();
      this.search();
    },
  },
};
</script>

<style lang="less">
</style>
